import './style.scss';
import { Button, DatePicker } from 'antd';
import { IAPIStudioInfo } from '../../../../../model/api-modules/studio';
import { WithdrawalDrawer } from './withdrawal-drawer';
import { useEffect, useState, useRef } from 'react';
// import { QuestionCircleOutlined } from '@ant-design/icons';
import warnBlueIcon from '../../../../../assets/svg/warn-blue.svg';
import successIcon from '../../../../../assets/images/message-success.png';
import moment from 'moment';
import getFormatMessage from '../../../../../locales/get-format-message';
import { ModalWrap } from '../../../../../components/modal-wrap';
import { IBillingAccountInfo } from '../../../../../model/billing-center/overview';
import { GetformatMoney } from './fomat-money';
import { getDrawHistoryList } from '../../../../../api';
import {
  DrawHistoryType,
  IDrawHistoryList,
} from '../../../../../model/billing-center/withdrawal';
import { getLocalTime } from '../../../../../lib';
import { RechargeRecordDrawer } from './recharge-record';
import { AutoTable } from '../../../../../components/auto-table';
import { IListItem } from '../../../../../components/auto-table/model';
import { PermissionCheck } from '../../../permission-check';
import { RbacRoleObjectKey } from '../../../../../model';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../../../store/reducers';

interface IProps {
  readonly studioInfo: IAPIStudioInfo;
  readonly balanceList: IBillingAccountInfo | null;
  readonly companyName: string | undefined;
  readonly onUpdate: () => void;
}

export const WithdrawalComponent = (props: IProps) => {
  const studioId = props.studioInfo.studio.StudioID;
  const [loading, setLoading] = useState<boolean>(false);
  const [drawer, setDrawer] = useState<boolean>(false);
  const [rechargeDrawer, setRechargeDrawer] = useState<boolean>(false);
  const [isDateRangeSelected, setIsDateRangeSelected] =
    useState<boolean>(false);
  const [dateRange, setDateRange] = useState<string[]>([]);
  const [withDrawalList, setWithDrawalList] = useState<
    ReadonlyArray<IDrawHistoryList>
  >([]);
  const [originalData, setOriginalData] = useState<
    ReadonlyArray<IDrawHistoryList>
  >([]);
  // 筛选处理
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [isShowModal, setIsShowModal] = useState<boolean>(false);
  const isMounted = useRef(false);
  const userInfo = useSelector((state: IRootState) => state.common.userInfo);

  const getWithDrawaList = async () => {
    setLoading(true);
    const res = await getDrawHistoryList(studioId);
    // console.log('提现列表数据items：', res);
    if (res) {
      setOriginalData(res.list);
      setWithDrawalList(res.list);
      handleFilter(res.list);
    }

    setLoading(false);
  };

  const handleDateRangeChange = (dates: any, dateStrings: string[]) => {
    if (!dates || dates.length === 0) {
      setDateRange(['', '']);
      setIsDateRangeSelected(false);
    } else {
      setDateRange(dateStrings);
      setIsDateRangeSelected(true);
    }
    handleFilter();
  };
  const handleFilter = (currentList?: readonly IDrawHistoryList[]) => {
    // 调接口时拿不到最新的值,可以直接传过来
    const currentData = currentList || originalData;
    const filtered = currentData.filter((item) => {
      const startDate = moment(dateRange[0], 'YYYY-MM');
      const endDate = moment(dateRange[1], 'YYYY-MM');
      const createTime = moment(item.create_time, 'YYYY-MM');
      const dateRangeMatch =
        !isDateRangeSelected ||
        createTime.isBetween(startDate, endDate, null, '[]');
      return dateRangeMatch;
    });
    setWithDrawalList(filtered);
  };
  useEffect(() => {
    getWithDrawaList();
  }, []);

  useEffect(() => {
    // 初始化拿不到数据，不执行
    if (isMounted.current) {
      handleFilter();
      setLoading(false);
    } else {
      isMounted.current = true;
    }
  }, [dateRange]);

  const handleCloseDrawer = (status?: boolean) => {
    setDrawer(false);
    if (status) {
      setIsShowModal(true);
      getWithDrawaList();
      props.onUpdate();
    }
  };
  const handleCloseModal = async () => {
    setIsShowModal(false);
    return true;
  };
  const renderModal = () => {
    if (isShowModal) {
      return (
        <ModalWrap
          width="450px"
          oKText={getFormatMessage('i_know')}
          onOk={handleCloseModal}
          // loading={loading}
          title={
            <div className="fail-title">
              <img
                src={successIcon}
                alt="Warning"
                style={{
                  marginRight: '10px',
                  marginTop: '-2px',
                  width: '16px',
                }}
              />
              {getFormatMessage('withdrawal_apply_commit')}
            </div>
          }
          className="fail-dialog"
        >
          <div
            style={{
              whiteSpace: 'pre-wrap',
              marginLeft: '20px',
              marginRight: '20px',
            }}
          >
            {getFormatMessage('withdrawal_modal_content')}
          </div>
        </ModalWrap>
      );
    }
    return null;
  };
  const handleWithdrawalReport = () => {
    setDrawer(true);
  };
  const renderWithdrawalDrawer = () => {
    if (drawer) {
      return (
        <WithdrawalDrawer
          onClose={handleCloseDrawer}
          currentMoney={props.balanceList?.account_balance}
          studioId={studioId}
          companyName={props.companyName}
        />
      );
    }
    return null;
  };
  const renderRechargeRecordDrawer = () => {
    if (rechargeDrawer) {
      return (
        <RechargeRecordDrawer
          onClose={() => setRechargeDrawer(false)}
          studioId={props.studioInfo.studio.StudioID}
        />
      );
    }
    return null;
  };
  const COLUMNS = [
    {
      name: getFormatMessage('apply_withdrawal_time'),
      key: 'create_time',
      tableExtension: {
        renderRow(_key: any, value: string | Date | undefined) {
          return <>{getLocalTime(value, userInfo?.UserSettings?.Timezone)}</>;
        },
      },
    },
    {
      name: getFormatMessage('withdrawal_money_and_icon'),
      key: 'amount',
    },
    {
      name: getFormatMessage('withdrawal_account'),
      key: 'draw_creator',
    },
    {
      name: getFormatMessage('recharge_update_time'),
      key: 'update_time',
      tableExtension: {
        renderRow(_key: any, value: string | Date | undefined) {
          return <>{getLocalTime(value, userInfo?.UserSettings?.Timezone)}</>;
        },
      },
    },
    {
      name: getFormatMessage('status'),
      key: 'draw_status',
      tableExtension: {
        renderRow(_key: any, value: string, row: IListItem) {
          const record = row as IDrawHistoryList;
          let text = '';
          let textDesc = '';
          let backgroundColor = '';
          switch (value) {
            case DrawHistoryType.Processing as unknown as string:
              text = getFormatMessage('draw_history_type_process');
              textDesc = getFormatMessage('draw_history_type_process_desc');
              backgroundColor = '#ACBAF9';
              break;
            case DrawHistoryType.Failed as unknown as string:
              text = getFormatMessage('draw_history_type_failed');
              backgroundColor = '#F54E4E';
              textDesc = record.draw_fail_detail || '';
              break;
            case DrawHistoryType.Completed as unknown as string:
              text = getFormatMessage('draw_history_type_completed');
              backgroundColor = '#3EC688';
              textDesc = record.draw_fail_detail || '';
              break;
            default:
              text = '';
              backgroundColor = '';
              break;
          }
          return (
            <>
              <span style={{ backgroundColor }} className="status-dot"></span>
              <span className="status-text">{text}</span>
              <span
                title={textDesc}
                style={{ color: '#86909C', marginLeft: '10px' }}
              >
                {textDesc}
              </span>
            </>
          );
        },
      },
    },
    {
      name: getFormatMessage('operate'),
      key: 'action',
      tableExtension: {
        renderRow(_value: any) {
          return (
            <span className="link-url" onClick={() => setRechargeDrawer(true)}>
              {getFormatMessage('draw_record')}
            </span>
          );
        },
      },
    },
  ];
  const onChangedFilterValues = () => {};
  const pageList = [...withDrawalList].slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  // console.log('withDrawalList44444444444444',withDrawalList);
  return (
    <div className="bi-child-container bi-withdrawal-container">
      <div className="re-report-description">
        <img src={warnBlueIcon} className="warn-blue-icon" />
        <div className="re-report-text">
          {getFormatMessage('draw_desc_content_1')}
        </div>
        <div className="re-report-text">
          {getFormatMessage('draw_desc_content_2')}
          <span className="withdrawal-yellow">
            {getFormatMessage('days_range')}
          </span>
          {getFormatMessage('draw_desc_content_3')}
          <span className="withdrawal-yellow">
            {getFormatMessage('days_range_7_15')}
          </span>
          {getFormatMessage('draw_desc_content_4')}
        </div>
        <div className="re-report-text">
          {getFormatMessage('draw_desc_content_5')}
          <span className="withdrawal-yellow">
            {getFormatMessage('days_range_over')}
          </span>
          {getFormatMessage('draw_desc_content_6')}
          <span className="withdrawal-yellow">
            {getFormatMessage('days_range_7_15')}
          </span>
          {getFormatMessage('draw_desc_content_7')}
        </div>
      </div>
      <div className="bi-recharge-top bi-withdrawal-top">
        <div className="recharge-title">
          <div className="recharge-title-info">
            <span>{getFormatMessage('can_withdraw_money')}</span>
            {/* <div className="balance-title-desc">
              <Tooltip
                title="xxxxxxxxxxxxxxxxxxx"
                // getPopupContainer={() => tooltipContainer}
                overlayClassName="edit-member-tooltip"
              >
                <QuestionCircleOutlined style={{ cursor: 'pointer' }} />
              </Tooltip>
            </div> */}
          </div>
          <PermissionCheck permissionKey={RbacRoleObjectKey.FeeCenterEdit}>
            <Button
              className="gc-btn gc-btn-primary btn-withdrawal"
              onClick={handleWithdrawalReport}
            >
              {getFormatMessage('withdraw_right_now')}
            </Button>
          </PermissionCheck>
        </div>
        <div className="recharge-top-content">
          <div className="recharge-user-info re-top-first">
            {/* <div className="re-value" title={'INGAME STUDIO(123456)'}> */}
            <div className="re-value">
              <GetformatMoney
                className="normal-withdrawal-money"
                money={props.balanceList?.account_balance}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="bi-recharge-bottom">
        <div className="recharge-title recharge-title-last">
          <span>{getFormatMessage('withdraw_record')}</span>
          <div className="billing-date-picker details-picker">
            <DatePicker.RangePicker
              dropdownClassName="fee-data-dropdown"
              value={
                isDateRangeSelected
                  ? [moment(dateRange[0]), moment(dateRange[1])]
                  : null
              }
              picker="month"
              onChange={handleDateRangeChange}
              monthCellRender={(date) => {
                return `${moment(date).format('MM')}`; // 修改中文显示为数字
              }}
            />
          </div>
        </div>
        <AutoTable
          loading={loading}
          list={pageList || []}
          configFields={COLUMNS}
          // className="re-withdrawal-table"
          tableExtension={{
            onChange: (changeInfo) => {
              if (!changeInfo) {
                return;
              }
              setCurrentPage(changeInfo.current);
              setPageSize(changeInfo.pageSize || 10);
            },
            pagination: {
              current: currentPage,
              total: withDrawalList.length,
              pageSize,
              showTotal: () => {
                return `Total ${withDrawalList.length} items`;
              },
            },
          }}
          layoutExtension={{
            showTopbar: false,
            showFilter: true,
          }}
          onChangedFilterValues={onChangedFilterValues}
        />
      </div>
      {renderWithdrawalDrawer()}
      {renderModal()}
      {renderRechargeRecordDrawer()}
    </div>
  );
};
